(ns kyber.components.base.text
  (:require [kyber.styles.core :refer [styles->classes gs]]))

(def text-styles
  (reduce
   (fn [acc [font-style font-color]]
     (merge acc {font-style {:font-size (gs [:font-size font-style])
                             :font-weight (gs [:font-weight font-style])
                             :line-height (gs [:font-height font-style])
                             :color font-color

                             (gs [:queries :tablet])
                             {:font-size
                              (gs [:font-size (-> font-style
                                                  name
                                                  (keyword "tablet"))])}

                             (gs [:queries :mobile-landscape])
                             {:font-size
                              (gs [:font-size (-> font-style
                                                  name
                                                  (keyword "mobile"))])}}}))

   {:base {:font-family (gs [:font-family :open-sans])
           :-webkit-text-size-adjust :none}
    :link {:cursor :pointer
           :text-decoration :none
           :color (gs [:colors :primary-lite-700])
           "&:active" {:color (gs [:colors :primary-lite-500])}

           (gs [:queries :hover])
           {"&:hover" {:color (gs [:colors :primary-lite-800])}}}}
   [[:display-10 (gs [:colors :gray-scale-600])]
    [:display-20 (gs [:colors :gray-scale-600])]
    [:title-40 (gs [:colors :gray-scale-600])]
    [:title-30 (gs [:colors :gray-scale-600])]
    [:title-20 (gs [:colors :gray-scale-600])]
    [:title-10 (gs [:colors :gray-scale-600])]
    [:body-30 (gs [:colors :gray-scale-500])]
    [:body-20 (gs [:colors :gray-scale-500])]
    [:body-10 (gs [:colors :gray-scale-500])]
    [:caption-30 (gs [:colors :gray-scale-500])]
    [:caption-20 (gs [:colors :gray-scale-500])]
    [:caption-10 (gs [:colors :gray-scale-500])]]))

(def classes (styles->classes text-styles))

(defn- render-text
  [tag
   text-key
   {:keys [class] :as options}
   content]
  [tag (assoc options :class
              (cond-> [(:base classes)
                       (text-key classes)]

                (string? class) (conj class)
                (coll? class) (concat class)
                (= tag :a) (conj (:link classes))))
   content])

(defn display-10
  {:doc "A display-10 tag is used for..."
   :id :display-10
   :version 0
   :variant :a}
  ([tag content] [display-10 tag {} content])
  ([tag options content]
   [render-text tag :display-10 options content]))

(defn display-20
  {:doc "A display-20 tag is used for..."
   :id :display-20
   :version 0
   :variant :a}
  ([tag content] [display-20 tag {} content])
  ([tag options content]
   [render-text tag :display-20 options content]))

(defn title-40
  {:doc "Title 40 tag is used for..."
   :id :title-40
   :version 0
   :variant :a}
  ([tag content] [title-40 tag {} content])
  ([tag options content]
   [render-text tag :title-40 options content]))

(defn title-30
  {:doc "Title 30 tag is used for..."
   :id :title-30
   :version 0
   :variant :a}
  ([tag content] [title-30 tag {} content])
  ([tag options content]
   [render-text tag :title-30 options content]))

(defn title-20
  {:doc "Title 20 tag is used for..."
   :id :title-20
   :version 0
   :variant :a}
  ([tag content] [title-20 tag {} content])
  ([tag options content]
   [render-text tag :title-20 options content]))

(defn title-10
  {:doc "Title 10 tag is used for..."
   :id :title-10
   :version 0
   :variant :a}
  ([tag content] [title-10 tag {} content])
  ([tag options content]
   [render-text tag :title-10 options content]))

(defn body-30
  {:doc "Body 30 tag is used for..."
   :id :body-30
   :version 0
   :variant :a}
  ([tag content] [body-30 tag {} content])
  ([tag options content]
   [render-text tag :body-30 options content]))

(defn body-20
  {:doc "Body 20 tag is used for..."
   :id :body-20
   :version 0
   :variant :a}
  ([tag content] [body-20 tag {} content])
  ([tag options content]
   [render-text tag :body-20 options content]))

(defn body-10
  {:doc "Body 10 tag is used for..."
   :id :body-10
   :version 0
   :variant :a}
  ([tag content] [body-10 tag {} content])
  ([tag options content]
   [render-text tag :body-10 options content]))

(defn caption-30
  {:doc "Caption 30 tag is used for..."
   :id :caption-30
   :version 0
   :variant :a}
  ([tag content] [caption-30 tag {} content])
  ([tag options content]
   [render-text tag :caption-30 options content]))

(defn caption-20
  {:doc "Caption 20 tag is used for..."
   :id :caption-20
   :version 0
   :variant :a}
  ([tag content] [caption-20 tag {} content])
  ([tag options content]
   [render-text tag :caption-20 options content]))

(defn caption-10
  {:doc "Caption 10 tag is used for..."
   :id :caption-10
   :version 0
   :variant :a}
  ([tag content] [caption-10 tag {} content])
  ([tag options content]
   [render-text tag :caption-10 options content]))
